<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-9 col-sm-12 col-12 no-gutters">
    <form [formGroup]="geTagRequestForm" class="col-xl-9 col-md-9 col-sm-12 col-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal"><strong>Application
          Description</strong>
      </h6>
      <div class="col-12 text-normal mb-3">
        GE Identification Tags provide enhanced traceability for the component and its serialized subcomponents (where
        applicable).
      </div>
      <mat-card *ngIf="comments" style="font-weight: 500; font-size: 18px;margin: 20px 0px;" [innerHTML]="comments"></mat-card>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="supplierName" name="supplierName" #supplierName placeholder=""
            maxlength="50">
          <mat-hint align="end">{{supplierName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">GSL & Site Code (9 Characters)
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="gslNumber" name="gslNumber" #gslNumber placeholder="" maxlength="9">
          <mat-hint align="end">{{gslNumber.value.length}} / 9</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          <span>
            Is this a new supplier?
            <span style="color: red;">*</span>
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="isNewSupplier" placeholder="Is this a new supplier?">
            <mat-option *ngFor="let item of types" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Date GE ID Tags Needed
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline"
          class="custom-date col-12 justify-content-center text-normal">
          <input tabindex="-1" matInput [min]="minDate" formControlName="date" [matDatepicker]="date">
          <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
          <mat-datepicker #date></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Ship to Address
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="shipToAddress" name="shipToAddress" #shipToAddress placeholder=""
            maxlength="50">
          <mat-hint align="end">{{shipToAddress.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Ship to City
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="shipToCity" name="shipToCity" #shipToCity placeholder="" maxlength="50">
          <mat-hint align="end">{{shipToCity.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Ship to State/Province
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="shipToState" name="shipToState" #shipToState placeholder="" maxlength="50">
          <mat-hint align="end">{{shipToState.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Ship to Postal Code
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="shipToZip" name="shipToZip" #shipToZip placeholder="" maxlength="50">
          <mat-hint align="end">{{shipToZip.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Country
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="country" name="country" #country placeholder="" maxlength="50">
          <mat-hint align="end">{{country.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Requestor Comments </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <!-- <input matInput formControlName="requestorComments" name="requestorComments" #requestorComments placeholder=""
                  maxlength="50"> -->
          <textarea matInput cols="100" rows="2" formControlName="requestorComments"
            name="requestorComments" #requestorComments placeholder=""></textarea>
          <mat-hint align="end">{{requestorComments.value.length}} / 280</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="row no-gutters col-12 justify-content-center">
          <div class="col-sm-12 pb-2">
            <div class="col-12 pb-2 px-0">
              <div class="py-2 border-box pl-2" style="margin-top: 1.25em;">
                <span class="text-normal" (click)="tagRequestTemplate()">
                  <img src="../../../../../assets/images/google-docs.svg" alt="" class="p-2" width="30" height="30">
                  <span class="align-middle p-2">Please click to download the Tag Request template, and then attach
                    completed template below</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--create-edit-stay-informed-->
      <div class="row col-12 mt-3 no-gutters" style="margin-bottom: 1.25em;">
        <div class="col-12 text-normal">Tag Request Template
          <span style="color: red;">*</span>
        </div>
        <div class="custom-flex" style="margin-top: 1.25em; width: 100%;"
          [ngClass]="{'error-highlight': fileNotUploaded}">
          <div class="custom-flex" style="width: 20%;">
            <button class="btn btn-outline-primary size-button" type="button" (click)=fileInput.click()>
              Choose file
            </button>
            <input #fileInput type="file" name="file-input" style="display: none"
              accept=".pdf, .doc, .docx, .xlsx, .xls, .jpg, .ppt, .pptx" (change)="onFileInput($event)" id="docFile" />
          </div>
          <div class="custom-flex ellipsis" style="width: 70%; align-items: center;">
            <div class="pr-3">{{fileName || 'No file chosen'}}</div>
          </div>
          <div class="custom-flex" style="align-items: center; width: 10%; justify-content: end;">
            <mat-icon aria-label="attach file" (click)="removeAttachment()" [matTooltip]="'Remove'">
              close
            </mat-icon>
          </div>
        </div>
      </div>
      <!-- <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Serialization Guides
        </div>
        <div class="row no-gutters col-12 justify-content-center">
          <div class="col-sm-12 pb-2">
            <div class="col-12 pb-2 px-0">
              <div class="py-2 border-box pl-2" style="margin-top: 1.25em;">
                <span class="text-normal" (click)="clearUsers()">
                  <img src="../../../../../assets/images/google-docs.svg" alt="" class="p-2" width="30" height="30">
                  <span class="align-middle p-2">Supplier serialization guide for clear orbit users</span>
                </span>
              </div>
              <div class="py-2 border-box pl-2" style="margin-top: 1.25em;">
                <span class="text-normal" (click)="nonClearUsers()">
                  <img src="../../../../../assets/images/google-docs.svg" alt="" class="p-2" width="30" height="30">
                  <span class="align-middle p-2">Supplier serialization guide for supplier support central(non-clear
                    orbit)
                    users</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row col-12 mt-3 no-gutters" style="margin-top: 2em !important;">
        <div class="col-12 text-normal">
          Business
          <span style="color: red;">*</span>
        </div>
        <div class="col-12 text-normal" style="margin-top: 12px;">
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            [ngClass]="{'error-highlight': geTagRequestForm.controls['business'].invalid && geTagRequestForm.controls['business'].touched}"
            formControlName="business" name="business">
            <mat-radio-button class="example-radio-button" *ngFor="let option of optionList" [value]="option">
              {{option}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          <span>
            Tag Style
            <span style="color: red;">*</span>
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="tagStyle" placeholder="Tag Style">
            <mat-option *ngFor="let item of tagStyleTypes" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Buyer Name </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="buyerName" name="buyerName" #buyerName placeholder="" maxlength="50">
          <mat-hint align="end">{{buyerName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Ship to Contact Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="shipToContactName" name="shipToContactName" #shipToContactName placeholder=""
            maxlength="50">
          <mat-hint align="end">{{shipToContactName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Phone Number
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="phoneNumber" name="phoneNumber" #phoneNumber placeholder="" maxlength="50">
          <mat-hint align="end">{{phoneNumber.value.length}} / 50</mat-hint>
          <!-- <mat-error class="custom-error" *ngIf="geTagRequestForm.controls.phoneNumber?.invalid">Please enter a valid Phone Number</mat-error> -->
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Ship to Email Address
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input matInput formControlName="emailAddress" name="emailAddress" #emailAddress placeholder=""
            maxlength="50">
          <mat-hint align="end">{{emailAddress.value.length}} / 50</mat-hint>
          <!-- <mat-error class="custom-error" *ngIf="geTagRequestForm.controls.emailAddress.invalid">Please enter a valid Email Address</mat-error> -->
        </mat-form-field>
      </div>
      <div class="row no-gutters col-12 d-flex align-items-center justify-content-center py-4">
        <button class="btn btn-primary btn-vernova button col-xl-5 col-md-6 col-sm-12 col-12" style="font-size: 18px;"
          (click)="submitGeTagRequestForm()">
          <span>
            Submit Request
          </span>
        </button>
      </div>
    </form>
  </div>

  <div class="col-sm-12 col-md-3 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary button btn-vernova col-12" style="font-size: 18px;" (click)="goToGuide()">
        <span>
          GE ID Tag Request Guide
          <i class='fa fa-download pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal">
        Contact your GE buyer with questions regarding orders, volume, etc.
      </div>
    </div>
    <hr>

    <div class="d-flex col-12 no-gutters">
      <h6><strong class="mt-3 text-lable">Request Created</strong></h6>
      <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
        <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;" (click)="getListTicket($event)"></i>
      </div>
    </div>
    <div class="col-12 border-box-status no-gutters d-flex align-items-center justify-content-center">
      <div class="col-11 no-gutters">
        <div class="col-12 text-normal no-gutters" *ngFor="let item of request; let first = first; let last = last">
          <div class="pt-3 col-12" *ngIf="first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="col-12" *ngIf="!first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="py-2">
            <div>
              Request ID number:
            </div>
            <div>{{item?.number}}</div>
            <!-- <a href="{{item?.requestUrl}}" target="_blank">
            {{item?.number}}
          </a> -->
          </div>
          <div class="pb-3" *ngIf="last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <div *ngIf="!last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>
    <hr>

    <div class="d-flex col-12 no-gutters">
      <h6><strong class="mt-3 text-lable">Request(s) Returned</strong></h6>
      <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
        <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;" (click)="getListTicket($event)"></i>
      </div>
    </div>
    <div class="col-12 border-box-status no-gutters d-flex align-items-center justify-content-center">
      <div class="col-11 no-gutters">
        <div class="col-12 text-normal no-gutters" *ngFor="let item of returned; let first = first; let last = last">
          <div class="pt-3 col-12" *ngIf="first">
            <div>
              Request returned at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="col-12" *ngIf="!first">
            <div>
              Request returned at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="py-2">
            <div>
              Request ID number:
            </div>
            <div style="cursor: pointer !important;" (click)="onRecordClick(item?.number)">{{item?.number}}</div>
            <!-- <a href="{{item?.requestUrl}}" target="_blank">
            {{item?.number}}
          </a> -->
          </div>
          <div class="pb-3" *ngIf="last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <div *ngIf="!last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>

  </div>
</div>